import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch, Link } from 'react-router-dom';

import styles from './BottomTabs.module.scss';
import ICONS from '../../static/media/icons/icons-helper';

const TabButton = ({ path, isSelected, children }) => {
  return (
    <div className={styles.tabButton}>
      <div
        className={`${styles.buttonContainer} ${
          isSelected && styles.selectedTab
        }`}
      >
        <Link className={styles.tabButtonText} to={path}>
          {children}
        </Link>
        <img
          className={styles.arrowIcon}
          src={ICONS.RIGHT_ARROW}
          alt="icon-img"
        />
      </div>
    </div>
  );
};

const BottomTabs = () => {
  const isWhatToBringPage = useRouteMatch('/what-to-bring');
  const isLawyersPage = useRouteMatch('/lawyers');

  return (
    <div className={styles.tabsContainer}>
      <TabButton isSelected={!!isWhatToBringPage} path="/what-to-bring">
        WHAT TO BRING
      </TabButton>
      <div className={styles.tabsSeparator} />
      <TabButton isSelected={!!isLawyersPage} path="/lawyers">
        PRO-BONO LAWYERS
      </TabButton>
    </div>
  );
};

TabButton.propTypes = {
  path: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  children: PropTypes.string.isRequired,
};

TabButton.defaultProps = {};

export default BottomTabs;
